import { render, staticRenderFns } from "./card-with-slider-rivoneed.vue?vue&type=template&id=4b1c04a6&scoped=true&"
import script from "./card-with-slider-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-with-slider-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-with-slider-rivoneed.vue?vue&type=style&index=0&id=4b1c04a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c04a6",
  null
  
)

export default component.exports